export default __webpack_public_path__ + "advantage-2c0cf13.png";